import React from "react";
import "./ContactUs.css";

const ContactUs = () => {
  return (
    <section className="contact-wrapper">
      <div className="container">

        <div className="contact-header">
          <h2>Contact Us</h2>
          <h3>Let’s Plan Your Next Journey or Corporate Event</h3>
          <p>
            Whether you are planning a curated family holiday, an international group tour, or a large-scale corporate conference, our dedicated teams are ready to assist you with structured planning and transparent guidance.
          </p>
          <p>
            For faster response, please connect with the relevant department below.
          </p>
        </div>

        {/* MAIN GRID START */}
        <div className="contact-main-grid">

          {/* LEFT SIDE */}
          <div className="left-section">

            <div className="department-section">
              <h3>Department Contacts</h3>

              <div className="dept-card">
                <h4>Corporate & MICE Desk</h4>
                <p>
                  For RFP submissions, conferences, incentive travel, exhibitions, corporate offsites, and business events.
                </p>
                <a href="mailto:mail@plenaryholidays.com">📧 mail@plenaryholidays.com</a><br/>
                <a href="tel:+919560321110">📞 +91-9560321110</a><br/>
                <a href="https://wa.me/919560321110" target="_blank" rel="noreferrer">WhatsApp</a>
              </div>

              <div className="dept-card">
                <h4>Leisure Travel & Sales</h4>
                <p>
                  For domestic holidays, international tours, fixed departures, family packages, and customized itineraries.
                </p>
                <a href="tel:+919555432221">📞 +91-9555432221</a><br/>
                <a href="mailto:mail@plenaryholidays.com">📧 mail@plenaryholidays.com</a><br/>
                <a href="https://wa.me/919555432221" target="_blank" rel="noreferrer">WhatsApp</a>
              </div>

              <div className="dept-card">
                <h4>B2B Marketing & Trade Partnerships</h4>
                <p>
                  For travel agent collaborations, DMC alliances, supplier partnerships, and marketing enquiries.
                </p>
                <a href="tel:+917218701234">📞 +91-7218701234</a><br/>
                <a href="https://wa.me/917218701234" target="_blank" rel="noreferrer">WhatsApp</a>
              </div>

              <div className="dept-card">
                <h4>24/7 Concierge & Emergency Support</h4>
                <p>
                  For urgent assistance during travel.
                </p>
                <a href="tel:+919560321110">📞 +91-9560321110</a><br/>
                <a href="https://wa.me/919560321110" target="_blank" rel="noreferrer">WhatsApp</a>
              </div>
            </div>

            <div className="dept-cardd office-section">
              <h3>Our Corporate Office</h3>
              <p>
                Plenary Holidays<br/>
                311, H-4, Vardhman North Ex Plaza<br/>
                Netaji Subhash Place, Pitampura<br/>
                New Delhi – 110034<br/>
                India
              </p>
              <p>
                We operate from a permanent, owned corporate office in Delhi, providing operational stability and professional infrastructure to manage complex corporate travel programs and large-scale group movements.
              </p>
            </div>

            <div className="why-connect">
              <h3>Why Connect With Plenary Holidays</h3>
              <ul>
                <li>16+ Years of Trusted Industry Experience</li>
                <li>Dedicated Leisure & MICE Divisions</li>
                <li>Registered Members of GAEHP & ADTOI</li>
                <li>Structured Planning & Transparent Pricing</li>
                <li>Established Corporate Infrastructure</li>
              </ul>
            </div>

          </div>

          {/* RIGHT SIDE FORM */}
          <div className="contact-form-section">
            <h3>Send Us Your Requirement</h3>
            <p>
              Kindly share your details and our team will respond within one business day.
            </p>

            <form className="contact-form">
              <input type="text" placeholder="Full Name" required />
              <input type="text" placeholder="Company Name (If Corporate)" />
              <input type="email" placeholder="Email Address" required />
              <input type="text" placeholder="Mobile Number" required />

              <select required>
                <option value="">Type of Enquiry (Dropdown):</option>
                <option>Leisure Holiday</option>
                <option>International Tour</option>
                <option>MICE / Conference</option>
                <option>Corporate Group Travel</option>
                <option>B2B Partnership</option>
                <option>Other</option>
              </select>

              <input type="text" placeholder="Preferred Travel / Event Dates" />
              <textarea placeholder="Message / Requirement Details"></textarea>

              <button type="submit">Submit Requirement</button>
            </form>
          </div>

        </div>
        {/* MAIN GRID END */}

      </div>
    </section>
  );
};

export default ContactUs;